export const DESCOPE_PROJECT_ID = 'P2s2TsaOffPNb7xnJXXBgTAH87LC';
export const DESCOPE_FLOW_IDS = {
  MAIN_SIGN_IN_SCREEN: 'sign-up-or-in-main',
  MEMBERS_INVITE_SCREEN: 'sign-up-or-in-members-invite',
};
export const AUTH_PROVIDERS = {
  DESCOPE: 'descope',
  FIREBASE: 'firebase',
  FIGMA_EMBED: 'figma_embed',
} as const;

// Trailing slash is intentional — prevents false matches on paths like /embedding
// or /embed-settings that share the prefix but aren't the embed route.
export const FIGMA_EMBED_ROUTE_PREFIX = '/embed/';

export const FIGMA_EMBED_ALLOWED_ORIGINS = ['https://www.figma.com', 'https://staging.figma.com'];
